import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import SwitchInput from '../../../../../Components/SwitchInput';
import CountryWiseDaisyChainData from './CountryWiseDaisyChainData';
import { Modalv2Context } from '../../../../../Contexts/Modalv2Context';
import ReactJson from 'react-json-view';
import { toast } from 'react-toastify';
import PageHeading from '../../../../../Components/PageHeading';
//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import useCommonStyles from '../../../../../commonStyles';
import { Paper, Grid, Divider, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ModalAddNewCountry from './ModalAddNewCountry';
import { COUNTRY_CODE_MAP, OPTIMIZED_TPV_CONFIG_KEYS } from '../../../../../core/constants';
import { PLATFORMS } from '../../../../../core/constants';
import OptimizedTpvConfig from './OptimizedTpvConfig';
//===============

const VastDaisyChaining = ({ keyData, featureDescription }) => {
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const daisyChainingConfig = rawConfig[keyData];
	const [selectedDaisyChainingCountry, setSelectedDaisyChainingCountry] = useState(
		checkAndGetDefaultCountry()
	);
	const { updateModalContent } = useContext(Modalv2Context);
	const optimizedTpvRequests = {
		optimizedTpvRequests: {
			enabled: rawConfig[OPTIMIZED_TPV_CONFIG_KEYS.OPTIMIZED_TPV_ENABLED],
			maxBackPocketAdsCapacity: rawConfig[OPTIMIZED_TPV_CONFIG_KEYS.OPTIMIZED_TPV_MAX_CAPACITY]
		}
	};


	// Resetting the daisy chaining country when the video section id changes
	useEffect(() => {
		setSelectedDaisyChainingCountry(checkAndGetDefaultCountry());
	}, [rawConfig.videoSectionId]);

	function checkAndGetDefaultCountry() {
		if (daisyChainingConfig && daisyChainingConfig.DEFAULT) {
			return 'DEFAULT';
		} else if (
			typeof daisyChainingConfig === 'object' &&
			Object.keys(daisyChainingConfig).length !== 0
		) {
			return Object.keys(daisyChainingConfig)[0];
		}
		return '';
	}

	// This function deletes the country from the daisy chaining config
	function deleteCountryFromDaisyChainingConfig() {
		if (selectedDaisyChainingCountry && selectedDaisyChainingCountry !== 'DEFAULT') {
			let deepClonedObj = structuredClone(rawConfig);
			if (daisyChainingConfig && daisyChainingConfig[selectedDaisyChainingCountry]) {
				delete deepClonedObj[keyData][selectedDaisyChainingCountry];
			}
			toast.success(`Country '${selectedDaisyChainingCountry}' deleted successfully`, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			setSelectedDaisyChainingCountry('');
			updateRawConfig(deepClonedObj);
		} else if (selectedDaisyChainingCountry === 'DEFAULT') {
			toast.error(`Can't delete DEFAULT country`, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		} else {
			toast.error(`Please select a country to delete`, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	}

	function updateDaisyChainingConfig(country, property, newValue) {
		let deepClonedObj = structuredClone(rawConfig);
		if (!deepClonedObj[keyData]) {
			deepClonedObj[keyData] = {};
		}
		if (!deepClonedObj[keyData][country]) {
			deepClonedObj[keyData][country] = {};
		}
		deepClonedObj[keyData][country][property] = newValue;
		updateRawConfig(deepClonedObj);
	}

	const getCountryNameListFromCode = () => {
		const countryNameList = Object.keys(daisyChainingConfig || {}).map((countryCode) => {
			if (countryCode === PLATFORMS.DEFAULT) {
				return {
					label: PLATFORMS.DEFAULT,
					value: PLATFORMS.DEFAULT
				};
			}

			return {
				label: `${COUNTRY_CODE_MAP[countryCode]} (${countryCode})`,
				value: countryCode
			};
		});
		return countryNameList;
	};
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Vast Daisy Chaining"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Vast Daisy Chaining']}
				description="Manage Country Wise Vast Daisy Chaining Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>

			<Box sx={{ marginLeft: '2rem', width: '95%' }}>
				<OptimizedTpvConfig keyData={OPTIMIZED_TPV_CONFIG_KEYS.OPTIMIZED_TPV_KEY} />

			</Box>

			<Divider sx={{ width: '95%', mx: 'auto' }} />

			<Typography variant="h6" sx={{ mb: 2, fontWeight: 600, marginTop: '2rem', marginLeft: '4.5rem' }}>
				Vast Daisy Chaining
			</Typography>

			<Grid container spacing={4} sx={{ mt: '2rem', ml: '4.5rem', mr: '4.2rem', width: '91%', border: '1px solid darkgrey', borderRadius: '7px', }}>
				<Grid
					item
					xs={12}
					style={{
						width: '95%',
						display: 'flex',
						justifyContent: 'flex-start',
						marginLeft: '1rem',
						padding: '1rem'
					}}
				>
					{selectedDaisyChainingCountry && (
						<Grid item xs={2} style={{ marginTop: '3.5rem', paddingLeft: '2rem' }}>
							<SwitchInput
								label="Enabled"
								disabled={false}
								isObjectEditor={false}
								containerStyles={{ marginTop: '1rem' }}
								directValue={
									!!(
										daisyChainingConfig && daisyChainingConfig[selectedDaisyChainingCountry]?.enabled
									)
								}
								updateDirectValue={(newValue) => {
									updateDaisyChainingConfig(selectedDaisyChainingCountry, 'enabled', newValue);
								}}
								keyData={keyData + `.${selectedDaisyChainingCountry}.enabled`}
							/>
						</Grid>
					)}

					<Grid item xs={6} style={{ marginBottom: '1.5rem', marginLeft: '5rem' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<DropDownSingle
								label="Country"
								isObjectEditor={false}
								directValue={selectedDaisyChainingCountry}
								updateDirectValue={setSelectedDaisyChainingCountry}
								list={getCountryNameListFromCode()}
								keyData={keyData}
							/>
							<AddCircleOutlineOutlinedIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								style={{ margin: '4rem 5rem 0 2rem' }}
								onClick={() =>
									updateModalContent(
										<ModalAddNewCountry
											activeCountryList={Object.keys(daisyChainingConfig || {})}
											daisyChainingConfig={daisyChainingConfig || (rawConfig[keyData] = {})}
										/>
									)
								}
							/>
							<DeleteOutlinedIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								style={{ margin: '4rem 7rem 0 -3rem' }}
								onClick={() => {
									deleteCountryFromDaisyChainingConfig();
								}}
							/>
						</div>
					</Grid>
				</Grid>

				{selectedDaisyChainingCountry && (
					<Grid item xs={12} style={{ width: '99%', paddingLeft: '2rem', paddingTop: '10px' }}>
						<CountryWiseDaisyChainData
							selectedDaisyChainingCountry={selectedDaisyChainingCountry}
							keyData={keyData + `.${selectedDaisyChainingCountry}`}
							daisyChainingConfig={daisyChainingConfig}
							updateDaisyChainingConfig={updateDaisyChainingConfig}
						/>
					</Grid>
				)}
			</Grid>

			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					marginTop: '5rem'
				}}
			>
				<Button
					variant="contained"
					onClick={() =>
						updateModalContent(
							<Box
								style={{
									position: 'absolute',
									bottom: '6rem',
									right: '50%',
									transform: 'translate(50%,50%)',
									width: '40rem',
									display: 'flex',
									justifyContent: 'space-between'
								}}
							>
								<Box className={classes.finalOverview}>
									<ReactJson
										enableClipboard={true}
										displayDataTypes={false}
										src={{
											vastDaisyChainingOptimizedConfig: optimizedTpvRequests || {},
											daisyChainingConfig: daisyChainingConfig || {}
										}}
										name={null}
									/>
								</Box>
							</Box>
						)
					}
				>
					Preview
				</Button>
			</div>
		</Paper>
	);
};
export default VastDaisyChaining;
